export function getRandomItem<T>(arr: T[] = []): T {
  const POS = Math.floor(Math.random() * arr.length);
  return arr[POS];
}
